// @wc-ignore-file
/**
 * CR-135: the current Kairo wordmark, shown in the logged-out top bar
 * (PublicHeader) and the signed-in invite bar (InviteHeader).
 *
 * Served from `public/` as a plain <img>, never imported from `src/`: the
 * svgr plugin turns every `src/**\/*.svg` import into a React component, which
 * would put ~11 kB of path data in the initial JS chunk. width/height are the
 * SVG's intrinsic size so the bar does not shift while it loads; the class
 * scales it to 28 px tall inside the 64 px bar.
 * The SVG's brand colours are hard-coded, so it cannot follow theme tokens:
 * fine while nothing applies `.dark`, but a dark header would need a second
 * asset.
 *
 * wuchale-ignored: "Kairo" is the brand name, the same in every locale.
 */
export const KairoLogo = () => (
  <img src="/kairo-wordmark.svg" alt="Kairo" width={161} height={34} className="h-7 w-auto" />
);
